import React, { useEffect, useState, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { getTermsAndConditions, createTermsAndCondition, updateTermsAndCondition } from 'api/termsAndCondition';
import { mutedText } from 'view/sessionLevelOffer/SessionLevelOfferList';

const validationSchema = Yup.object().shape({
  version: Yup.string().trim().required('Version is required'),
  link: Yup.string().trim().required('Link is required'),
});

const TermsAndConditionForm = () => {
  const { tncId } = useParams();
  const { navigateTo } = useContext(NavContext);
  const [tnc, setTnc] = useState({});
  const isReadOnly = !!tncId && !tnc.is_active;

  useEffect(() => {
    tncId && getTermsAndConditions().then((res) => setTnc(_.find(res.data, { id: tncId }) || {}));
  }, [tncId]);

  const onSubmit = (values) => {
    const body = _.pick(values, ['version', 'link', 'details']);
    return (tncId ? updateTermsAndCondition(tncId, body) : createTermsAndCondition(body))
      .then(() => {
        toast.success(tncId ? 'T&C updated' : 'New T&C version is now active');
        navigateTo('/termsAndConditions');
      })
      .catch(() => {});
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={!tncId ? 'Add T&C Version' : isReadOnly ? 'View T&C Version' : 'Edit Active T&C'} backTo="/termsAndConditions" />
        <div className="page-content-wrapper scrollable">
          <Card>
            <div className="p-4">
              <p style={mutedText}>
                {!tncId
                  ? 'Saving makes this the active version in the app right away. Users who never accepted get the accept pop-up; others move to it on their next login.'
                  : isReadOnly
                    ? 'Old version, kept as users accepted it.'
                    : 'Edits change the active version in place and nobody is asked again. For new terms, add a new version instead.'}
              </p>
              <Formik
                enableReinitialize
                initialValues={{ version: tnc.version || '', link: tnc.link || '', details: tnc.details || '' }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <fieldset disabled={isReadOnly}>
                      <div className="section-heading mb-3">Version details</div>
                      <Row>
                        <Col lg={3}>
                          <TextInput
                            isRequired
                            label="Version"
                            placeholder="e.g. 2.0"
                            name="version"
                            value={values.version}
                            onChange={handleChange}
                            error={touched.version && errors.version}
                          />
                        </Col>
                        <Col lg={9}>
                          <TextInput
                            isRequired
                            label="Link"
                            name="link"
                            value={values.link}
                            onChange={handleChange}
                            error={touched.link && errors.link}
                          />
                        </Col>
                        <Col lg={12}>
                          <TextInput
                            as="textarea"
                            rows={4}
                            label="Details (Optional)"
                            name="details"
                            value={values.details}
                            onChange={handleChange}
                          />
                        </Col>
                      </Row>
                    </fieldset>
                    <div className="d-flex justify-content-end mt-4" style={{ gap: 12 }}>
                      <Button className="cancel_btn" onClick={() => navigateTo('/termsAndConditions')}>
                        Cancel
                      </Button>
                      {!isReadOnly && (
                        <Button type="submit" className="save-btn" disabled={isSubmitting}>
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};

export default TermsAndConditionForm;
